import React from 'react';
import { NavLink } from "react-router-dom";
import logo from "../images/logo.png";

function Header() {
  const style = { color: "#ABAEC1", width: "98px", height: "31px", position: "absolute", top: "25px", left: "25px", right: "1317px", bottom: "23px" }

  return (
    <>
      <header className="Header-nav">

        <div className="logo-container">
          <h1>SmartBiz</h1>
        </div>

        <nav>
          <ul className="list">

            <li>
              <NavLink className="navigate" to="/">
                Features
            </NavLink>
            </li>

            <li>
              <NavLink className="navigate" to="/Community">
                Community
            </NavLink>
            </li>

            <li>
              <NavLink className="navigate" to="/Pricing">
                Pricing
            </NavLink>
            </li>

            <li>
              <NavLink className="navigate" to="/Blog">
                Learn
            </NavLink>
            </li>

            <li className="login">
              <NavLink className="login-nav" to="/Login">
                Login
            </NavLink>
            </li>

            <li className="SignUp">
              <NavLink className="SignUp-nav" to="/SignUp">
                Get Started
            </NavLink>
            </li>

          </ul>
        </nav>
        {/* <img src={logo} style={style} alt="This is the Logo Image" /> */}
      </header>
    </>
  );
}

export default Header;
